import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { McdStateProgressChart } from '../charts/McdStateProgressChart';

export const McdInvDashboardMapView = ({ formValues, endDateToStartDate }) => {

  return (
    <SpacerLayout>
      <Spacer>
        <DashboardCard title="Quarterly Invoice Progress by State">
          <McdStateProgressChart
            formValues={formValues}
            endDateToStartDate={endDateToStartDate}
          />
        </DashboardCard>
      </Spacer>
    </SpacerLayout>
  );
};